import { COMPETITIVE_KIT_IDS, DEFAULT_AWAY_KIT, DEFAULT_HOME_KIT, KIT_IDS } from "@golazo/shared";
import { FIXED_CLUBS } from "./names.js";

/**
 * Las equipaciones y la carrera.
 *
 * Al principio solo se tienen dos: el rojo y el azul (decision del usuario:
 * "es la unica manera de conseguir equipaciones"). Todas las demas se ganan en
 * la carrera y se visten tambien online:
 *
 *  - La de cada club con el que ACABAS una temporada: una temporada con su
 *    camiseta es lo que te la hace tuya.
 *  - La de un rival al que ganas siendo el MVP: os cambiais la camiseta.
 *  - Las de premio (`REWARD_KITS`): nadie las viste en el mundo, solo se
 *    ganan con hitos. Son las mas vistosas a proposito.
 */
export const STARTER_KITS: readonly string[] = [DEFAULT_HOME_KIT, DEFAULT_AWAY_KIT];

export interface RewardKit {
  kitId: string;
  /** Que hay que hacer, en una frase (clave de `t()`). */
  how: string;
}

export const REWARD_KITS: readonly RewardKit[] = [
  { kitId: "burdeosOro", how: "Gana tu primera liga, la que sea." },
  { kitId: "negroOro", how: "Llega a Primera." },
  { kitId: "blancoOro", how: "Gana la Primera." },
  { kitId: "medianoche", how: "Marca 50 goles en tu carrera." },
  { kitId: "lava", how: "Marca 150 goles en tu carrera." },
  { kitId: "electrico", how: "Da 50 asistencias en tu carrera." },
  { kitId: "arlequin", how: "Sé el MVP 25 veces." },
  { kitId: "hielo", how: "Juega 100 partidos de carrera." },
  { kitId: "radiactivo", how: "Asciende dos veces seguidas." },
  { kitId: "tricolor", how: "Entra en el salón de la fama." },
];

/** Las que se reparten entre los clubes: ni de salida, ni de premio, ni de un fijo. */
export function clubKitPool(): string[] {
  const reserved = new Set([
    ...STARTER_KITS,
    ...REWARD_KITS.map((r) => r.kitId),
    ...FIXED_CLUBS.map((f) => f.kitId),
    // Las de competicion no las viste ningun club: se ganan online.
    ...COMPETITIVE_KIT_IDS,
  ]);
  return KIT_IDS.filter((id) => !reserved.has(id));
}
